/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl';
        var dict = require('../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/**
 * OSTATNIO UZYWANE NARZEDZIA — Fala 4D (25.09.2026).
 *
 * Maly, lokalny, wersjonowany magazyn skrotow do narzedzi, ktorych czlowiek
 * RZECZYWISCIE uzyl w tej przegladarce: generator (po wylosowaniu),
 * sprawdzarka kuponu (po uruchomieniu sprawdzenia z liczbami) i analizator
 * zestawu (po przeliczeniu). Samo wejscie na strone, render, focus czy zmiana
 * rozmiaru nie jest uzyciem — magazyn dostaje sygnal tylko ze zdarzenia DOM
 * wyslanego przez narzedzie w chwili dzialania.
 *
 * KLUCZ `pewniaki:ostatnie-narzedzia:v1`: { v: 1, wpisy: [ { n, g, t } ] }
 *   n — kod narzedzia z NARZEDZIA, g — kod gry (albo null), t — czas lokalny
 *   (ms) potrzebny tylko do porzadku. NIC WIECEJ: zadnych liczb, nazw zestawow,
 *   wynikow, adresow, query stringow ani zawartosci innych kluczy.
 *   Najwyzej LIMIT (3) unikalnych par narzedzie+gra, najnowsza pierwsza;
 *   ponowne uzycie przenosi wpis na poczatek bez duplikatu.
 *
 * Sygnaly:
 *   - `pewniaki:narzedzie-uzyte` (CustomEvent bubbles, detail {narzedzie, gra})
 *     wysylany przez sprawdzarke (sprawdz-kupon.html.twig) i analizator
 *     (pages/analizator-ui.js);
 *   - `pewniaki:wygenerowano` na [data-gen] (generator.html.twig, istniejace
 *     zdarzenie Fali 1) — gra z `gen.mzOstatnie.gra`.
 *
 * Widok: strona glowna, `[data-on-ostatnie]` (index.html.twig). Wiersze buduje
 * skrypt z mapy tras `#ostatnie-narzedzia-trasy` (adresy policzone w Twigu
 * przez adresTrasy()/analizaAdres()). Wpis bez trasy albo z nieznana gra jest
 * pomijany; bez poprawnych wpisow sekcja zostaje `hidden`. Uszkodzony JSON,
 * brak localStorage i QuotaExceededError nie psuja strony.
 *
 * Test: node bin/test-ostatnie-narzedzia.js (bez DOM),
 *       node ai/test-fala-4-1-dom.js (przegladarka, lokalny serwer).
 */
(function (root, fabryka) {
    'use strict';
    var api = fabryka(root);
    if (typeof module === 'object' && module && module.exports) { module.exports = api; }
    root.PewniakiNarzedzia = api;
    if (root.document && root.document.getElementById) { api.startStrony(root.document); }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
    'use strict';

    var KLUCZ = 'pewniaki:ostatnie-narzedzia:v1';
    var WERSJA = 1;
    var LIMIT = 3;
    var NARZEDZIA = ['generator', 'sprawdzarka', 'analizator'];
    var ZDARZENIE = 'pewniaki:narzedzie-uzyte';
    var KOD_GRY = /^[a-z][a-z0-9-]{1,20}$/;

    function pusty() { return { v: WERSJA, wpisy: [] }; }

    /** Jeden wpis: poprawny albo null. `gry` (lista kodow) zaweza gre, gdy podana. */
    function normalizujWpis(w, gry) {
        if (!w || typeof w !== 'object') { return null; }
        var n = typeof w.n === 'string' ? w.n : null;
        if (NARZEDZIA.indexOf(n) < 0) { return null; }
        var g = null;
        if (w.g !== null && w.g !== undefined) {
            if (typeof w.g !== 'string' || !KOD_GRY.test(w.g)) { return null; }
            if (gry && gry.indexOf(w.g) < 0) { return null; }
            g = w.g;
        }
        var t = typeof w.t === 'number' && isFinite(w.t) && w.t > 0 ? Math.floor(w.t) : null;
        if (t === null) { return null; }
        return { n: n, g: g, t: t };
    }

    /**
     * Magazyn. opcje: { magazyn: obiekt Storage (testy; domyslnie localStorage),
     * gry: [kody] (walidacja gry; brak = tylko ksztalt kodu), teraz: fn -> ms }.
     */
    function utworz(opcje) {
        opcje = opcje || {};
        var gry = Array.isArray(opcje.gry) && opcje.gry.length ? opcje.gry.slice() : null;
        var teraz = typeof opcje.teraz === 'function' ? opcje.teraz : function () { return Date.now(); };

        function sklep() {
            try {
                var s = opcje.magazyn !== undefined ? opcje.magazyn : root.localStorage;
                if (!s || typeof s.getItem !== 'function') { return null; }
                return s;
            } catch (e) { return null; }
        }
        /** { stan: 'ok' | 'pusty' | 'uszkodzony' | 'niedostepny', wpisy: [] } */
        function odczyt() {
            var s = sklep();
            if (!s) { return { stan: 'niedostepny', wpisy: [] }; }
            var surowe;
            try { surowe = s.getItem(KLUCZ); } catch (e) { return { stan: 'niedostepny', wpisy: [] }; }
            if (surowe === null || surowe === undefined || surowe === '') { return { stan: 'pusty', wpisy: [] }; }
            var d;
            try { d = JSON.parse(surowe); } catch (e) { return { stan: 'uszkodzony', wpisy: [] }; }
            if (!d || typeof d !== 'object' || d.v !== WERSJA || !Array.isArray(d.wpisy)) { return { stan: 'uszkodzony', wpisy: [] }; }
            var out = [], klucze = {};
            for (var i = 0; i < d.wpisy.length && out.length < LIMIT; i++) {
                var w = normalizujWpis(d.wpisy[i], gry);
                if (!w) { continue; }
                var k = w.n + '|' + (w.g || '');
                if (klucze[k]) { continue; }
                klucze[k] = true;
                out.push(w);
            }
            return { stan: 'ok', wpisy: out };
        }
        function zapis(wpisy) {
            var s = sklep();
            if (!s) { return false; }
            var tekst = JSON.stringify({ v: WERSJA, wpisy: wpisy });
            try { s.setItem(KLUCZ, tekst); } catch (e) { return false; }
            try { return s.getItem(KLUCZ) === tekst; } catch (e) { return false; }
        }
        /** Najnowszy pierwszy, tylko poprawne, bez duplikatow, najwyzej LIMIT. */
        function lista() { return odczyt().wpisy.map(function (w) { return { n: w.n, g: w.g, t: w.t }; }); }
        /** Sygnal rzeczywistego uzycia. Zwraca true tylko po udanym zapisie. */
        function zanotuj(narzedzie, gra) {
            var nowy = normalizujWpis({ n: narzedzie, g: gra === undefined ? null : gra, t: teraz() }, gry);
            if (!nowy) { return false; }
            var stare = odczyt().wpisy.filter(function (w) { return !(w.n === nowy.n && w.g === nowy.g); });
            return zapis([nowy].concat(stare).slice(0, LIMIT));
        }
        function wyczysc() {
            var s = sklep();
            if (!s) { return false; }
            try { s.removeItem(KLUCZ); return true; } catch (e) { return false; }
        }
        return { KLUCZ: KLUCZ, LIMIT: LIMIT, lista: lista, zanotuj: zanotuj, wyczysc: wyczysc, stan: function () { return odczyt().stan; } };
    }

    /* ── WIDOK NA STRONIE GLOWNEJ ───────────────────────────────────────── */

    /** Adres wpisu z mapy tras; null = brak trasy (wpis pomijany). */
    function adresWpisu(trasy, w) {
        if (!trasy || typeof trasy !== 'object') { return null; }
        var t = trasy[w.n];
        if (!t) { return null; }
        if (typeof t === 'string') {
            if (w.g && trasy.gry && trasy.gry.indexOf(w.g) < 0) { return null; }
            return t;
        }
        if (typeof t === 'object') {
            // { url, gra: true } -> url?gra=kod ; { kod: url } -> per gra
            if (typeof t.url === 'string') {
                if (!w.g) { return t.gra ? null : t.url; }
                if (!trasy.gry || trasy.gry.indexOf(w.g) < 0) { return null; }
                return t.gra ? t.url + (t.url.indexOf('?') < 0 ? '?' : '&') + 'gra=' + encodeURIComponent(w.g) : t.url;
            }
            if (w.g && typeof t[w.g] === 'string') { return t[w.g]; }
        }
        return null;
    }

    function etykieta(en, w, trasy) {
        var nazwy = en
            ? { generator: jst("ui.3850f3b4d1ba72eb"), sprawdzarka: jst("ui.047ccc4d2eeba776"), analizator: jst("ui.da8152918a439c27") }
            : { generator: jst("ostatnie_narzedzia_js.literal.a35d4b301ae0"), sprawdzarka: jst("ui.e546a99a600a7698"), analizator: jst("ui.8eacad8cf9387bb6") };
        var gra = w.g && trasy && trasy.nazwy && trasy.nazwy[w.g] ? trasy.nazwy[w.g] : w.g;
        return nazwy[w.n] + (gra ? ' — ' + gra : '');
    }

    function czyEn(doc) { return /^en(?:-|$)/i.test((doc.documentElement && doc.documentElement.lang) || ''); }

    function trasyStrony(doc) {
        var el = doc.getElementById('ostatnie-narzedzia-trasy');
        if (!el) { return null; }
        try { var d = JSON.parse(el.textContent || '{}'); return d && typeof d === 'object' ? d : null; } catch (e) { return null; }
    }

    /** Sekcja [data-on-ostatnie]: wypelnia liste i zdejmuje `hidden` tylko przy >= 1 poprawnym wpisie. */
    function widok(doc, S, box) {
        var trasy = trasyStrony(doc), lista = box.querySelector('[data-on-ostatnie-lista]');
        if (!trasy || !lista) { box.hidden = true; return 0; }
        var en = czyEn(doc), ile = 0;
        while (lista.firstChild) { lista.removeChild(lista.firstChild); }
        S.lista().forEach(function (w) {
            var href = adresWpisu(trasy, w);
            if (!href) { return; }
            var li = doc.createElement('li'), a = doc.createElement('a'), tekst = doc.createElement('span');
            a.setAttribute('href', href);
            a.className = 'home-link-akcja home-link-akcja--pelna';
            a.setAttribute('data-on-narzedzie', w.n);
            if (w.g) { a.setAttribute('data-on-gra', w.g); }
            var wzor = box.querySelector('template[data-on-ikona="' + w.n + '"]');
            if (wzor && wzor.content) { a.appendChild(wzor.content.cloneNode(true)); }
            tekst.textContent = etykieta(en, w, trasy);
            a.appendChild(tekst);
            li.appendChild(a);
            lista.appendChild(li);
            ile++;
        });
        box.hidden = ile === 0;
        return ile;
    }

    var instancja = null;
    function sklepStrony(doc) {
        if (!instancja) {
            var trasy = doc ? trasyStrony(doc) : null;
            instancja = utworz({ gry: trasy && Array.isArray(trasy.gry) ? trasy.gry : null });
        }
        return instancja;
    }

    function startStrony(doc) {
        function start() {
            var S = sklepStrony(doc);
            // Sygnaly rzeczywistego uzycia (sprawdzarka, analizator).
            doc.addEventListener(ZDARZENIE, function (e) {
                var d = e && e.detail;
                if (d && typeof d.narzedzie === 'string') { S.zanotuj(d.narzedzie, typeof d.gra === 'string' ? d.gra : null); }
            });
            // Generator: istniejace zdarzenie Fali 1 na [data-gen], gra z mzOstatnie.
            var gen = doc.querySelector('[data-gen]');
            if (gen) {
                gen.addEventListener('pewniaki:wygenerowano', function () {
                    var o = gen.mzOstatnie;
                    if (o && o.zestawy && o.zestawy.length) { S.zanotuj('generator', typeof o.gra === 'string' ? o.gra : null); }
                });
            }
            var box = doc.querySelector('[data-on-ostatnie]');
            if (box) { widok(doc, S, box); }
        }
        if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
    }

    return {
        KLUCZ: KLUCZ, WERSJA: WERSJA, LIMIT: LIMIT, NARZEDZIA: NARZEDZIA.slice(), ZDARZENIE: ZDARZENIE,
        utworz: utworz, normalizujWpis: normalizujWpis, adresWpisu: adresWpisu, etykieta: etykieta,
        widok: widok, sklep: sklepStrony, startStrony: startStrony
    };
});
